module.exports = __webpack_public_path__ + "static/media/callgage-seo-header.a63666b5.png";